<template>
  <b-dialog :mshow="show">
    <register @register="onRegister" @cancel="onCancel" @login="onLogin"/>
  </b-dialog>
</template>

<script>
import Register from '@/components/app-login/register.vue'
import Slide from '@/components/slide'
import BDialog from '@/components/dialog/login-dialog.vue'

export default {
  components: {
    Register,
    Slide,
    BDialog
  },
  data () {
    return {
      show: false
    }
  },
  methods:{
    onRegister: function(){
      this.$emit("register-success")
    },
    onCancel: function(){
      this.$emit("register-cancel")
    },
    onLogin: function(){
      this.$emit("to-login")
    }
  }
}
</script>



// WEBPACK FOOTER //
// register.vue?5ddb0492